import { useApp, useAuth } from '@hb/react'
import { useMemo } from 'react'
import { SignInModal } from '../Auth/SignInModal'
import { SiteSettingsModal } from '../Settings/SiteSettings'
import { ContactFormModal } from './Contact/ContactFormModal'
import { EmailVerificationModal } from './EmailVerificationModal'
import { InvitePatientModal } from './InvitePatientModal'
import { TwoFactorAuthModal } from './MultiFactor/TwoFactorAuthModal'
import { NameEntryModal } from './NameEntryModal'
import { NavigationGuardModal } from './NavigationGuardModal'
import { PushNotificationsSettingsModal } from './PushNotificationsSettingsModal'

export const RootModals = () => {
  const claims = useAuth(s => s.claims)
  const admin = useAuth(s => s.admin)
  const { appName } = useApp()
  const canInvite = useMemo(() => admin || appName === 'providers-app', [admin, appName])
  return (
    <>
      <NavigationGuardModal />
      <PushNotificationsSettingsModal />
      <NameEntryModal />
      {claims?.email_verified ? null : <EmailVerificationModal />}
      {canInvite ? <InvitePatientModal /> : null}
      <TwoFactorAuthModal />
      <ContactFormModal />
      <SiteSettingsModal />
      <SignInModal />
    </>
  )
}
